<template>
    <dashboard v-if="user">
        <row>
            <panel>
                <h3 slot="title">Security</h3>
                <app-form
                    ref="passwordForm"
                    :model="password"
                    :rules="rules"
                    @submit.native.prevent="submit">
                    <p class="required-fields">All fields marked with * are required</p>
                    <grid :columns="['1fr', '1fr', '1fr']">
                        <grid-item col_start="1" col_end="2">
                            <app-form-item label="Current Password" prop="current_password">
                                <app-input
                                    id="current_password"
                                    v-model="password.current_password"
                                    type="password" />
                            </app-form-item>
                        </grid-item>
                        <grid-item col_start="1" col_end="2">
                            <app-form-item label="New Password" prop="new_password">
                                <app-input
                                    id="new_password"
                                    v-model="password.new_password"
                                    type="password" />
                            </app-form-item>
                        </grid-item>
                        <grid-item>
                            <app-form-item label="Confirm New Password" prop="confirm_password">
                                <app-input
                                    id="confirm_password"
                                    v-model="password.confirm_password"
                                    type="password"/>
                            </app-form-item>
                        </grid-item>
                    </grid>
                    <app-button
                        :loading="isSaving"
                        type="primary"
                        native-type="submit"
                        size="large">Save</app-button>
                </app-form>
            </panel>
        </row>
    </dashboard>
</template>

<script>
import User from '@/store/models/User'

import Panel from '../../ui/Panel'

export default {
    name: 'page-users-security',
    components: {
        Panel
    },
    props: ['id'],
    data() {
        return {
            isSaving: false,
            password: {
                current_password: '',
                new_password: '',
                confirm_password: ''
            },
            rules: {
                current_password: [
                    {
                        required: true,
                        message: 'Please input a current password',
                        trigger: 'blur'
                    }
                ],
                new_password: [
                    {
                        required: true,
                        message: 'Please input a new password',
                        trigger: 'blur'
                    }
                ],
                confirm_password: [
                    {
                        required: true,
                        message: 'Please input the password confirmation',
                        trigger: 'blur'
                    },
                    {
                        validator: this.checkConfirmPassword,
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    computed: {
        user() { return User.find(this.id) }
    },
    methods: {
        checkConfirmPassword(rule, value, callback) {
            if (value !== this.password.new_password) {
                callback(new Error('The two password fields must match'))
            }
            else {
                callback()
            }
        },
        submit() {
            this.$refs['passwordForm'].validate(valid => {
                if (!valid) return

                this.isSaving = true
                User.$mutate({
                    graphql: 'password',
                    variables: {
                        id: this.user.id,
                        current_password: this.password.current_password,
                        new_password: this.password.new_password
                    }
                })
                    .then(() => {
                        this.displaySuccess()
                    })
            })
        },
        displaySuccess() {
            this.isSaving = false
            this.password = {
                current: '',
                newPass: '',
                confirmPass: ''
            }
            this.$notify({
                title: 'Success',
                message: 'The password has been successfully changed!',
                type: 'success',
                offset: 75,
                duration: 2000
            })
        }
    }
}
</script>

<style lang="stylus"></style>
